import api from "./api";

export default class HomeApi {
  static async getVisitorCount(data) {
    return await api.get(`visit`, data);
  }

  static async getMemberCount(data) {
    return await api.get(`member/home/count`, data);
  }
}
